<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">cooperative enterprise</div>
      <div class="contentTitle">合作企业</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="imgBox w">
        <div class="imgItem" v-for="(item, index) in imgObj" :key="index">
          <img :src="item.url" alt />
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentStitle">cooperative enterprise</div>
      <div class="contentTitle">合作企业</div>
      <div class="imgBox">
        <div class="imgItem" v-for="(item, index) in imgObj" :key="index">
          <img :src="item.url" alt />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      imgObj: [
        { url: src.hzqy_1},
        { url: src.hzqy_2 },
        { url: src.hzqy_3 },
        { url: src.hzqy_4 },
        { url: src.hzqy_5 },
        { url: src.hzqy_6 },
        { url: src.hzqy_7 },
        { url: src.hzqy_8 },
        { url: src.hzqy_9 },
        { url: src.hzqy_10 },
        { url: src.hzqy_11 },
        { url: src.hzqy_12 },
      
      ],
    };
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .contentBox {
    display: none;
  }
  .mobile_contentBox {
    .imgBox {
      width: 330px;
      margin: 0 auto 20px;
      height: 350px;
      .imgItem {
        float: left;
        width: 100px;
        height: 60px;
        border: 1px solid #cccccc;
        margin-right: 15px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 80%;
        }
      }
      .imgItem:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .mobile_contentBox {
    display: none;
  }
  .contentBox {
    .imgBox {
      margin: 20px 0;
      height: 600px;
      .imgItem {
        float: left;
        width: 285px;
        height: 167px;
        border: 1px solid #cccccc;
        margin-right: 20px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 270px;
        }
      }
      .imgItem:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}
</style>
